const ASK_SCAN_LOCATION_KEY = "ask_scan_location";

function readAskScanLocation() {
  try {
    return window.sessionStorage.getItem(ASK_SCAN_LOCATION_KEY)?.trim() || "";
  } catch (_error) {
    return "";
  }
}

function storeAskScanLocation(value) {
  const stored = `${value || ""}`.trim();
  if (!stored) {
    return;
  }
  try {
    window.sessionStorage.setItem(ASK_SCAN_LOCATION_KEY, stored);
  } catch (_error) {
    // sessionStorage can be blocked. The search record still carries the area.
  }
}

export { ASK_SCAN_LOCATION_KEY, readAskScanLocation, storeAskScanLocation };
